import { i18nCasePage as caseTranslations } from './case.i18n';
export const i18nComponents = {
  table: {
    ALL: 'Selecionar Tudo',
    '-': '(Vazia)',
  },
  notifications_manager: {
    tabs: {
      NEW: 'Adicionar Novo',
      LIST: 'Notificações',
      EDIT: 'Editar',
    },
    notifications_list: {
      toggle: 'Me Notifique sobre atualizações em casos em que sou o proprietário',
    },
    select_asset: 'Selecionar um ativo',
    save: 'Salvar notificação',
    description: 'Digite uma descrição para esta notificação',
    frequency: 'Frequências',
    select_frequency: 'Selecionar frequência',
    frequency_options: {
      DAILY: 'Diariamente',
      MONDAYS: 'Segundas-feiras',
      TUESDAYS: 'Terças-feiras',
      WEDNESDAYS: 'Quartas-feiras',
      THURSDAYS: 'Quintas-feiras',
      FRIDAYS: 'Sextas-feiras',
      SATURDAYS: 'Sábados',
    },
    notification_type: {
      title: 'Sobre o que você deseja ser notificado?',
      alarms: {
        title: 'Alarmes',
        models: {
          placeholder: 'Selecionar modelos',
          emptyOptions: 'Nenhum modelo disponível para este ativo',
          all: 'Todos os modelos',
        },
        categories: {
          placeholder: 'Selecionar categorias',
          emptyOptions: 'Nenhuma categoria disponível para este ativo',
          all: 'Todas as categorias',
        },
      },
    },
  },
  permissioned_button: {
    unauthorized:
      'Desculpe, você não pode executar essa ação devido a permissões limitadas. Entre em contato com o administrador do sistema.',
  },
  downloadCSVButton: {
    tooltip: 'Baixe um arquivo CSV com a lista abaixo',
  },
  scallingModels: {
    status: { high: 'Alto', low: 'Bom', medium: 'Médio' },
    statusDetail: {
      HIGH: '(risco 0,75 a 1,00)',
      LOW: '(risco abaixo de 0,50)',
      MEDIUM: '(risco 0,50 a 0,75)',
    },
  },
  event_list: {
    id: 'ID do evento',
    asset_name: 'Equipamento',
    classification: 'Classificação',
    description: 'Descrição do evento',
    model: 'Modelo',
    start_time: 'Data e hora',
    status: 'Status',
    type: 'Tipo',
    filters: {
      asset: 'Equipamento',
      copy: 'Copiar itens da tabela para a área de transferência',
      export_csv: 'Exportar itens da tabela para arquivo CSV',
      period: 'Período',
      search: 'Pesquisar',
      copied_success: 'Itens da tabela copiados para a área de transferência',
    },
  },
  date_filter: {
    reference_date: 'Data de referência',
    creation: 'Início',
    closing: 'Fim',
    period: 'Período',
    alarm: 'Alarme',
    alarm_period: 'Alarme atual',
    event_period: 'Evento atual',
    last_n_days: 'Últimos {{days}} dias',
    last_n_hours: 'Últimas {{hours}} horas',
    max_period: 'Período máximo',
    all: 'Todos',
    custom: 'Customizado',
    start_date: 'Início',
    end_date: 'Fim',
    real_time: 'Em tempo real',
    date: {
      lts: 'DD/MM/YYYY',
      datetime_minute: 'DD/MM/YYYY HH:mm',
      datetime_second: 'DD MMM HH:mm:ss',
      month_year: 'MMM/YYYY',
    },
    invalid_range: 'O intervalo deve ser menor que {{maxMonthsRange}} meses',
  },
  asset_card: {
    alarm: {
      alarm_zero: 'Sem alarmes',
      alarm_one: '{{count}} alarme',
      alarm_other: '{{count}} alarmes',
    },
    event: {
      event_zero: 'Sem eventos',
      event_one: '{{count}} evento',
      event_other: '{{count}} eventos',
    },
    sensor: {
      delayed: {
        delayed_zero: 'Nenhum sensor em atraso',
        delayed_one: '{{count}} sensor em atraso',
        delayed_other: '{{count}} sensores em atraso',
      },
      offline: {
        offline_zero: 'Nenhum sensor offline',
        offline_one: '{{count}} sensor offline',
        offline_other: '{{count}} sensores offline',
      },
      active: {
        active_zero: 'Nenhum sensor ativo',
        active_one: '{{count}} sensor ativo',
        active_other: '{{count}} sensores ativos',
      },
      no_data: {
        no_data_zero: 'Nenhum sensor sem dados',
        no_data_one: '{{count}} sensor sem dados',
        no_data_other: '{{count}} sensores sem dados',
      },
    },
    fallback: {
      alarms: 'Erro ao carregar dados de alarmes',
      events: 'Erro ao carregar dados de eventos',
      sensors: 'Erro ao carregar dados de sensores',
      models: 'Erro ao carregar dados de modelos',
    },
  },
  breadcrumb: {
    go_back: 'Voltar',
  },
  footer: {
    my_requests: 'Minhas solicitações',
  },
  header: {
    asset_tree: {
      open_editing_mode: 'Abrir modo de edição',
      exit_editing_mode: 'Sair do modo de edição',
      title: 'Árvore de ativos',
    },
    tab_menu: {
      alarms: 'Alarme',
      events: 'Alarme',
      sensors: 'Sensor',
      vet: 'VET',
      monitoring: 'Monitoramento',
      models: 'Modelos',
      overview: 'Visão geral',
      users_and_roles: 'Usuários e Funções',
      access_levels: 'Níveis de acesso',
      notifications: 'Notificações',
      deviations: 'Desvio de Condição',
      reports: 'Relatório',
      health: 'Saúde do ativo',
      oil_system: 'Performance',
    },

    user_menu: {
      greeting: 'Olá, {{user}}',
      exit: 'Sair',
      language: {
        'pt-BR': 'Português',
        es: 'Español',
        en: 'English',
      },
      users_and_permissions: 'Usuários e Permissões',
      notifications: 'Notificações',
      sound_alert: 'Alerta sonoro',
      help: 'Ajuda',
    },
  },
  image_uploader: {
    action: {
      select: 'Selecione uma imagem',
      send: 'Enviar',
      delete: 'Remover',
    },
    title: 'Upload de imagem',
    tooltip: 'Selecione uma imagem para habilitar o botão de envio',
  },
  login: {
    email: 'E-mail',
    login_btn: 'Prossiga para entrar',
  },
  private_route: {
    confirm: 'OK',
    message: {
      access_denied: {
        title: 'Acesso negado',
        message: 'Você não tem permissão para acessar essa funcionalidade',
      },
    },
  },
  pump_curve_graph: {
    updated_at: 'Dados de {{timestamp}}',
    update_rate: 'Atualizado a cada {{interval}} {{unit}}',
    no_timeline_data_for_the_selected_period:
      'Nenhum dado de timeline encontrado para o período selecionado',
    legend: {
      rotation: 'Rotação',
      pump_operation: 'Operação da bomba',
      optimal_range: 'Faixa ideal',
    },
  },
  sensors_graph: {
    legend: {
      data: 'Dados',
      threshold: 'Limites',
      risk_area: 'Período de risco',
      alarm: 'Alarme + período de risco',
    },
    no_value: 'Sem valor',
    clear_zoom: 'Limpar zoom',
    message: {
      no_sensors_selected: {
        title: 'Nenhum sensor selecionado',
        message: 'Selecione pelo menos um item',
      },
      no_data: {
        title: 'Nenhum dado encontrado',
        message: 'Por favor, aplique outros filtros ou tente novamente em alguns minutos',
      },
      generic_error: {
        title: 'Ops..',
        message:
          'Não foi possível obter dados dos sensores. Aguarde alguns minutos e tente novamente ',
      },
    },
    tabs: {
      sensors: 'Sensores',
      features: 'Recursos',
    },
  },
  radar_graphic: {
    title: 'Visão de radar',
    message: {
      no_data: {
        title: 'Nenhum dado encontrado',
        message: 'Por favor, aplique outros filtros ou tente novamente em alguns minutos',
      },
    },
  },
  line_chart: {
    title: 'Gráfico de linha',
    no_data: 'Dados não encontrados',
    error: 'Ocorreu um error ao carregar os dados, tente mais tarde',
  },
  plot_scaling: {
    title: 'Visão gráfica',
    legend: {
      no_alarming: 'Sem alarme',
      warning: 'Aviso',
      learned_region: 'Região aprendida',
      alarming: 'Alarme de escala',
      upper_limit: 'Upper Limit',
      target_region: 'Target Region',
      lower_limit: 'Lower Limit',
    },
    tooltip: {
      date: 'Data e hora',
      itens: 'Itens Agrupados',
    },
    message: {
      model_version: 'Versão do modelo',
      selected_period_is_older:
        'O período selecionado é mais antigo do que a versão do modelo e não será totalmente exibido',
    },
  },
  authorized_users: {
    tabs: {
      authorized_users: 'Usuários Autorizados',
      groups: 'Grupos',
    },
    table_headers: {
      name: 'Nome',
      email: 'E-mail',
      roles: 'Funções',
      groups: 'Grupos',
      created: 'Criado',
      status: 'Status',
    },
    chars_limit: 'Limite de 24 caracteres',
    add_user: 'Adicionar Usuário',
    select_roles: 'Selecione as funções',
    select_value_to_save: 'Selecione um valor para salvar',
    modal: {
      add_user: 'Adicionar Usuário',
      name: 'Nome',
      enter_name: 'Digite o nome',
      email: 'E-mail',
      users: 'Usuários',
      enter_email: 'Digite o e-mail',
      roles: 'Funções',
      enter_roles: 'Digite as funções',
      required_field: 'Este campo é obrigatório',
    },
    roles_success: 'As funções do usuário foram editadas com sucesso',
    roles_group_success: 'As funções do grupo foram editadas com sucesso',
    group_data_success: 'Os dados do grupo foram editados com sucesso',
  },
  user_groups: {
    group_name: 'Nome do grupo',
    users: 'Usuários',
    roles: 'Funções',
    status: 'Status',
    placeholder: 'Digite ou cole e-mails de usuários',
    add_user_to_group: 'Adicionar usuários ao grupo',
    delete_user_from_group: 'Excluir usuário do grupo',
    cancel: 'Cancelar',
    yes_delete_user: 'Sim, excluir usuário',
    delete: 'Excluir',
    from_group: 'do grupo',
    new_group: 'Novo Grupo',
    add_group: 'Adicionar Grupo',
    no_users: 'Sem Usuários',
  },
  access_levels: {
    table_headers: {
      group: 'Grupo',
      attribute: 'Atributo',
      values: 'Valores',
    },
    select_group: 'Selecione um grupo',
    select_attribute: 'Selecione um atributo',
    select_values: 'Selecione valores',
  },
  upload_tree: {
    switch_off_configuration: {
      modal_title: 'Configurar regra de ligado/desligado',
      condition: 'Condição de desligamento',
      description: 'Descrição',
      created_at: 'Criado em {{date}}',
      version: 'Versão {{version}}',
      on: 'ligado',
      off: 'desligado',
      actions: {
        create: 'Criar modelo',
        cancel: 'Cancelar',
        save: 'Salvar modelo',
        delete: 'Excluir modelo',
      },
      addRuleLabel: 'Adicionar regra',
      fieldPlaceholder: 'Selecionar tag',
      messages: {
        no_model: {
          title: 'Este equipamento não possui um modelo de ON/OFF em execução',
          msg: 'Você pode criar um modelo com uma ou mais regras para desligar o equipamento e seus respectivos filhos. Enquanto as condições forem atendidas, os demais modelos serão desligados.',
        },
        no_tags: {
          title: 'Este equipamento não possui tags',
          message: 'Verifique o cadastro de tags deste equipamento e tente novamente.',
        },
        in_processing: 'Criação de modelo em fila de processamento. Por favor, aguarde',
        generic_error: {
          title: 'Ops..',
          message: 'Ocorreu um erro inesperado. Aguarde alguns minutos e tente novamente',
        },
        update_model: {
          success: { title: 'Sucesso', message: 'Modelo atualizado' },
          error: { title: 'Erro', message: 'Falha ao atualizar modelo' },
        },
        delete_model: {
          success: { title: 'Sucesso', message: 'Modelo excluído' },
          error: { title: 'Erro', message: 'Falha ao excluir modelo' },
        },
      },
    },
    add_asset_child: 'Adicionar ativo como filho',
    add_asset_same_level: 'Adicionar ativo no mesmo nível',
    add_attribute: 'Adicionar atributo',
    add_new_tag_line: 'Adicionar nova linha',
    asset: 'Ativo',
    assets: 'Ativos',
    asset_name: 'Nome do ativo',
    attribute_name: 'Nome do atributo',
    attributes: 'Atributos',
    cancel: 'Cancelar',
    categories: 'Categorias',
    choose_a_file: 'Escolha um arquivo',
    create_new_asset: 'Criar novo ativo',
    delete_asset_and_children: 'Excluir ativo e filhos',
    delete_asset: 'Excluir ativo',
    delete_this_line: 'Excluir esta linha',
    description: 'Descrição',
    download_template: 'Modelo',
    errorCodes: {
      LH_AT_001:
        'O valor do campo na coluna `parent_asset_name` é muito longo. O comprimento máximo é 100 caracteres.',
      LH_AT_002: 'O valor do campo na coluna `name` é muito longo. O comprimento máximo é 100.',
      LH_AT_003:
        'O valor do campo na coluna `screen_name` é muito longo. O comprimento máximo é 40.',
      LH_AT_004:
        'O valor do campo na coluna `description` é muito longo. O comprimento máximo é 200.',
      LH_AT_005:
        'O valor do campo na coluna `view_order` é muito pequeno. O valor mínimo na coluna é 1.',
      LH_AT_006:
        'O valor do campo na coluna `asset_name` é muito longo. O comprimento máximo é 100.',
      LH_AT_007: 'O valor do campo na coluna `tag` é muito longo. O comprimento máximo é 200.',
      LH_AT_009: 'O valor do campo na coluna `unit` é muito longo. O comprimento máximo é 50.',
      LH_AT_010: 'O valor do campo na coluna `type` é muito longo. O comprimento máximo é 100.',
      LH_AT_012: 'O valor do campo na coluna `type` é muito longo. O comprimento máximo é 50.',
      LH_AT_013: 'O valor do campo na coluna `type` deve ser `int`, `float` ou `string`.',
      LH_AT_014: 'O valor do campo na coluna `value` é muito longo. O comprimento máximo é 500.',
      LH_AT_015: 'A coluna não pode conter valores nulos.',
      LH_AT_016: 'Coluna não encontrada no arquivo.',
      LH_AT_017: 'A coluna contém valores duplicados.',
      LH_AT_018: 'A coluna deve conter apenas valores inteiros.',
      LH_AT_019: 'O ativo já existe no banco de dados.',
      LH_AT_020: 'Ativo com caractere especial no arquivo.',
      LH_AT_021: 'Categorias com caractere especial no arquivo.',
      LH_AT_022: 'O ativo pai não existe no banco de dados.',
      LH_AT_023:
        'Prefixo da tag com formato inválido, caracteres especiais ou espaço em branco. Deve estar no formato `prefixo/prefixo_opcional/`.',
      LH_AT_024: 'Tag duplicada encontrada no arquivo.',
      LH_AT_025: 'O nome do recurso não existe no banco de dados.',
      LH_AT_026: 'A tag já existe no banco de dados.',
      LH_AT_027: 'A coluna deve conter apenas valores decimais (número de ponto flutuante).',
      LH_AT_028: 'Formato de arquivo inválido. Faça upload apenas do arquivo de dados CSV UTF-8.',
    },
    file_successfully_uploaded: 'arquivo(s) enviado(s) com sucesso',
    file: 'Arquivo',
    field_name: 'Nome do campo',
    field_format: 'Formato do campo',
    found_following_errors: 'Encontramos os seguintes erros no arquivo.',
    please_review: 'Por favor, revise e envie novamente.',
    loading_csv: 'Por favor, aguarde enquanto processamos sua solicitação',
    guidelineMessages: {
      asset: {
        parent_asset_name: 'nome do sistema do ativo pai',
        categories:
          'limite de 100 caracteres, apenas letras minúsculas, números e sublinhado. Separe por vírgula para inserir mais de uma categoria.',
        name: 'limite de 100 caracteres, apenas letras minúsculas, números e sublinhado.',
        screen_name: 'Nome de exibição no sistema. Limite de 40 caracteres, livre.',
        description: 'limite de 200 caracteres, livre.',
        view_order: 'número inteiro',
      },
      tags: {
        asset_name: 'limite de 100 caracteres, somente letras minúsculas, números e underline.',
        tag: 'limite de 200 caracteres, sem espaço.',
        tag_prefix:
          'limite de 100 caracteres, nulo(vazio) ou texto no formato texto/text_opcional.',
        description: 'limite de 200 caracteres.',
        unit: 'limite de 50 caracteres.',
        type: 'limite de 100 caracteres.',
        threshold: 'número decimal ou nulo (vazio).',
      },
      attributes: {
        asset_name: 'Limite de 100 caracteres, apenas letras minúsculas, números e sublinhado.',
        name: 'Limite de 100 caracteres, apenas letras minúsculas, números e sublinhado.',
        type: 'Limite de 100 caracteres.',
        value: 'Limite de 100 caracteres.',
      },
    },
    guidelines: 'Orientações',
    edit_asset: 'Editar ativo',
    exit_editing_mode: 'Sair do modo de edição',
    float: 'Número decimal',
    hi: 'Hi',
    hihi: 'HiHi',
    lo: 'Lo',
    lolo: 'LoLo',
    high_threshold: 'Hi',
    high_high_threshold: 'HiHi',
    low_threshold: 'Lo',
    low_low_threshold: 'LoLo',
    number: 'Número inteiro',
    parent_asset: 'Ativo pai',
    press_enter_to_add: 'Pressione ENTER após digitar para adicionar nova categoria',
    return_to_upload: 'Voltar para o upload',
    root_asset_null: 'Ativo raiz (nulo)',
    save_asset: 'Salvar ativo',
    screen_name: 'Nome de visualização',
    select_add: 'Selecione e/ou digite novo',
    select_file_on_computer: 'Selecione um arquivo',
    string: 'Texto',
    submit: 'Enviar',
    system_name: 'Nome no sistema',
    tag_code: 'Tag/Código',
    tag_name: 'Nome da tag',
    tag_prefix: 'Prefixo',
    tags: 'Tags',
    type: 'Tipo',
    unit: 'Unidade',
    upload_csv_files: 'Envie arquivos CSV',
    upload_files: 'Enviar arquivos',
    value: 'Valor',
    view_order: 'Ordem de visualização',
    update: 'Atualizar',
    messages: {
      add_all_the_required_files: 'Anexe todos os arquivos necessários',
      add_only_to_existing_asset: 'Só é possível adicionar tags a ativos já existentes.',
      delete_confirmation:
        'Tem certeza que deseja deletar o ativo e todos seus filhos? Esta ação não pode ser desfeita.',
      disabled_tags_editing_create_asset_first:
        'É necessário criar um ativo antes de adicionar tags',
      duplicate_attribute_name:
        'Nome de atributo duplicado, por favor escolha nomes diferentes para cada campo',
      error_pattern: 'Somente letras minúsculas, números e underline',
      error_pattern_number: 'Somente números',
      feature_under_development: 'Funcionalidade em desenvolvimento',
      fill_the_required_fields: 'Preencha os campos obrigatórios',
      max_length: 'Máximo de {{maxLength}} caracteres',
      min_value: 'Valor mínimo: {{minValue}}',
      name_already_exists: 'Este nome já existe, escolha outro',
      not_displayed_and_cannot_be_changed: 'Não será exibido e não poderá ser alterado',
      root_if_no_parent: 'Se nenhum ativo pai for selecionado, o ativo será criado no nível raiz',
      this_field_is_required: 'Este campo é obrigatório',
      type_asset_screen_name_to_confirm: 'Digite o nome de visualização do ativo para confirmar',
      type_ok_to_confirm: 'Digite OK para confirmar',
      the_asset_was_created_successfully: 'O ativo foi criado com sucesso',
      there_was_an_error_creating_the_asset_try_again:
        'Ocorreu um erro ao criar o ativo, tente novamente mais tarde',
    },
  },
  notifications: {
    title: 'Suas Notificações de Alarme',
    helperText:
      'Enviaremos uma notificação de alarme para o endereço de e -mail que você usa para fazer login, na frequência escolhida (sempre às 7:00).',
    item: 'notificação',
    empty: 'Nenhuma notificação configurada. Você pode ',
    emptyLink: 'adicionar uma nova notificação.',
    columns: {
      email: 'Email',
      whatsapp: 'Whatsapp',
      frequency: 'Frequência',
      model_label: 'Modelo',
      asset: 'Ativo',
      edit: '',
      description: 'Descrição',
      subjects: 'Notificações',
    },
    alarm_type: {
      model: 'Modelo',
      category: 'Categoría',
      all: 'Todos',
    },
    frequency: {
      daily: 'Diário',
      mondays: 'Seg',
      tuesdays: 'Ter',
      wednesdays: 'Qua',
      thursdays: 'Qui',
      fridays: 'Sex',
      saturdays: 'Sab',
      sunday: 'Dom',
      by_asset: 'Por Ativo',
    },
    form: {
      title: 'Adicionar nova notificação',
      labels: {
        email: 'Email',
        whatsapp: 'Whatsapp',
        frequency: 'Frequência',
        model: 'Selecionar um Modelo',
        asset: 'Selecionar um Ativo',
        switchOn: 'ON',
        switchOff: 'OFF',
      },
      placeholders: {
        modelWithoutAsset: 'Aguardando seleção de ativo',
      },
      buttons: {
        add: 'Adicionar',
        save: 'Salvar',
        edit: 'Editar',
        duplicate: 'Duplicar',
        delete: 'Eliminar',
      },
    },
  },
  Case: { ...caseTranslations.status, ...caseTranslations.severity },
  ConditionDeviation: {
    openAsset: 'Abrir Ativo',
    newCd: 'Novo CD',
    openNewCD: 'Criar nova Desvio de Condição',
    editCD: 'Editar Desvio de Condição',
    asset: 'Ativo',
    newAsset: 'Selecione um ativo',
    asset_id: 'ID do Ativo',
    dimension: 'Dimensão',
    category: 'Categoria',
    category_id: 'Id da Categoria',
    detection_method: 'Método de Detecção',
    deviation_start: 'Início do desvio',
    deviation_end: 'Fim do desvio',
    duration: 'Duração',
    diagnosis: 'Diagnóstico',
    detailing: 'Detalhamento',
    recommended_action: 'Ações recomendadas',
    actionStatus: 'Status da ação',
    sap_note: 'Nota',
    sapNoteTooltip: 'O campo de Nota é obrigatório com o status de ação “Ação emitida”',
    assetConditionEvaluation: 'Aval. de condição',
    condition_evaluation: 'Aval. de condição',
    assetStatus: 'Status do ativo',
    savings: 'Economias',
    savings_required: 'Economias',
    savingsNoteTooltip: 'Economias é um campo opcional e pode ser preenchido posteriormente',
    description: 'Descrição',
    equipment_class: 'Classe de ativo',
    subunit: 'Subunidade',
    maintainable_item: 'Item manutenível',
    failureMode: 'Modo de falha',
    failure_mechanism: 'Mecanismo de falha',
    maintenance_scope: 'Escopo de manutenção',
    noFillesAttached: 'Nenhum arquivo anexado',
    attachFile: 'Anexar arquivo',
    alarmsLinked: '{{alarmsCount}} Alarmes vinculados',
    toThisCD: 'a esse Desvio de Condição',
    addViewAlarms: 'Adicionar/visualizar alarmes ativos',

    is_out_of_service: 'Equipamento pode operar?',
    outOfServiceOptions: {
      yes: 'Capaz de operar',
      no: 'Incapaz de operar',
    },
    options: {
      action_status: {
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Ação emitida',
        CANCELED: 'Cancelado',
        UNDER_EVALUATION: 'Em avaliação',
        COMPLETED: 'Concluído',
      },
      condition_evaluation: {
        NORMAL_CONDITION: 'Baixo',
        ALARM_CONDITION: 'Médio',
        CRITICAL_CONDITION: 'Muito Alto',
        POTENTIAL_PROBLEM: 'Alto',
        NOT_MONITORED: 'Não Monitorado',
        NOT_OPERATED: 'Não Operado',
        modec: {
          NORMAL_CONDITION: 'Condição Normal',
          ALARM_CONDITION: 'Condição de Alarme',
          CRITICAL_CONDITION: 'Condição Crítica',
          POTENTIAL_PROBLEM: 'Problema Potencial',
          NOT_MONITORED: 'Não Monitorado',
          NOT_OPERATED: 'Não Operado',
        },
      },

      dimensions: {
        AUXILIARY_SYSTEM: 'Sistema auxiliar',
        PROCESS_CONDITION: 'Condição de processo',
        DYNAMIC_CONDITION: 'Condição dinâmica',
        OIL_ANALYSIS: 'Análise de óleo',
      },
    },
    confirmChangeAsset:
      'Ao alterar o Ativo, os alarmes vinculados serão apagados. Continuar mesmo assim?',
    yesContinue: 'Sim, continuar',
    save: 'Salvar',
    placeholders: {
      assetName: 'Comece a digitar para exibir opções',
      dimension: 'Selecionar dimensão',
      selectAnOption: 'Selecionar uma opção',
      select: 'Selecionar',
      dayHour: 'Escolha dia e hora',
      diagnosis: 'Insira o diagnóstico do desvio',
      detailing: 'Insira detalhes',
      recommendedActions: 'Insira recomendações',
      sapCode: 'Insira a Nota ',
      description: 'Um breve resumo sobre o evento de economia',
    },
    messages: {
      toBeRequired: 'Este campo é obrigatório',
      duplicate_attribute_name: 'Nome de atributo duplicado',
      only_numbers: 'Apenas números',
      confirmTurnOffCannotOperate:
        'Tem certeza de que deseja desativar o status NÃO PODE OPERAR para este equipamento?',
      confirmTurnOnCannotOperate:
        'Tem certeza de que deseja ativar o status NÃO PODE OPERAR para este equipamento?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    modalTitles: {
      new: 'Abrir novo Desvio de Condição',
      edit: 'Desvio de Condição',
    },
    conditionEvaluation: {
      POTENTIAL_PROBLEM: 'Alto',
      CRITICAL_CONDITION: 'Muito Alto',
      ALARM_CONDITION: 'Médio',
      NORMAL_CONDITION: 'Baixo',
    },
  },
  upload: {
    attach_file: 'Anexar arquivo',

    infoText:
      'Você só pode anexar um arquivo por vez, Formatos permitidos: {{acceptFiles}} com tamanho de até {{maxFileSize}}Mb',
    noFillesAttached: 'Nenhum arquivo anexado',
    errorFiles: 'Você só pode anexar um arquivo por vez',
    duplicatedFile: 'Este arquivo já foi anexado',
    maxFileSize: 'O tamanho do arquivo excede o limite de {{maxFileSize}}Mb',
    invalidFormat: 'Formato de arquivo inválido. Formatos permitidos: {{acceptFiles}}',
    snackbar: {
      success: { title: 'Upload de Arquivo', text: 'upload com sucesso' },
      error: { title: 'Upload de Arquivo', text: 'erro no upload' },
    },
    add: {
      title: 'Arquivo adicionado',
      text: 'Arquivo adicionado com sucesso, o upload será realizado ao salvar',
    },
    error: 'Erro',
    deleteModal: {
      title: 'Excluir arquivo',
      text: 'Este arquivo será excluído permanentemente e não poderá ser recuperado',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      snackbar: {
        success: { title: 'Arquivo Excluído', text: 'Arquivo excluído com sucesso' },
        error: { title: 'Arquivo não Excluído', text: 'Erro ao excluir' },
      },
    },
  },
  list: { chart: 'Gráfico', noData: 'Nenhum dado encontrado para esta seção' },
  inputs: {
    required_field: 'Este campo é obrigatório',
    invalid_date: 'Data inválida',
  },
  statusSelectWithButton: {
    label: {
      save: 'Salvar',
      saved: 'Salvo',
      selectPrefix: 'Estágio:',
      cancel: 'Cancelar',
      saveDescription: 'Salvar descrição',
    },
  },
  noData: 'Sem dados',
  caseListItem: {
    options: {
      dimensions: {
        auxiliary_system: 'Sistema Auxiliar',
        process_condition: 'Condição de Processo',
        dynamic_condition: 'Condição Dinâmica',
        oil_analysis: 'Análise de Óleo',
      },
    },
  },
  external_reference: {
    type: {
      '': 'Selecione ref.',
      SAP: 'Nota SAP',
      OTHER: 'Outro',
    },
    type_label: 'Referência externa',
    code_label: 'Código de referência externa',
    placeholders: {
      selectReference: 'Selecione ref.',
      code: 'Digite o código',
    },
  },
  status_indicators: {
    models_alarming: 'Modelos alarmando',
    cases_opened: 'Casos abertos',
  },
  custom_toolbar: {
    headings: {
      1: 'Título 1',
      2: 'Título 2',
      3: 'Título 3',
      4: 'Título 4',
      5: 'Título 5',
      6: 'Título 6',
      normal: 'Normal',
    },
  },
};
